<template>
  <v-navigation-drawer
    :value="drawerLeft"
    :stateless="true"
    fixed
    app
  >
    <v-list dense>
      <v-list-item>
          <v-list-item-icon>
          <v-btn icon text href="#fav" color="green">
            <v-icon>favorite</v-icon>
          </v-btn>
          </v-list-item-icon>
        <v-list-item-content>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn icon text href="#pin" color="grey">
            <v-icon>mdi-pin-outline</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>

      <v-list-item-group v-model="item" color="primary">
        <v-list-item
          v-for="item in favs" :key="item.route"
          @click="$route.path != item.route ? $router.push({path: item.route}) : null"
        >
          <v-list-item-content>
            <v-list-item-title>
              <span class="padL">{{ item.title }}</span>
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action @click="removeBookmark(item)">
            <v-icon>mdi-heart-off</v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-list-item-group>

      <v-list-item>
        <span>Sichten</span>
      </v-list-item>
      <v-list-group
        v-for="item in views"
        :key="item.title"
        :value="true"
        :active="true"
        :prepend-icon="item.action"
        :append-icon="null"
        no-action
        sub-group
      >
        <template v-slot:activator>
          <v-list-item @click.stop="lastAction = item.action">
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <v-list-item
          v-for="subItem in item.items"
          :key="subItem.title"
          @click="lastAction = item.action"
        >
          <v-list-item-content>
            <v-list-item-title>{{ subItem.title }}</v-list-item-title>
          </v-list-item-content>

          <v-list-item-action>
            <v-checkbox v-model="subItem.active" label="" @change="onItemActiveChange(item.key, subItem.key, subItem.active)"></v-checkbox>
          </v-list-item-action>
        </v-list-item>
      </v-list-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  data() {
    return {
      lastAction: '',
      item: '',
      views: [
        {
          action: 'keyboard_arrow_right',
          title: 'Themen / Termine',
          key: 'event',
          active: true,
          items: [
            { title: 'Basisdients', key: 'bas', active: false },
            { title: 'Medien', key: 'med', active: false },
            { title: 'Sozial', key: 'soz', active: false },
            { title: 'LD West', key: 'ldw', active: false },
            { title: 'LD Ost', key: 'ldo', active: false },
            { title: 'LD Nord', key: 'ldn', active: false },
          ],
        },
        {
          action: 'keyboard_arrow_right',
          title: 'Inhalte',
          key: 'content',
          active: true,
          items: [
            { title: 'Basisdients', key: 'bas', active: false },
            { title: 'Medien', key: 'med', active: false },
            { title: 'Sozial', key: 'soz', active: false },
            { title: 'LD West', key: 'ldw', active: false },
            { title: 'LD Ost', key: 'ldo', active: false },
            { title: 'LD Nord', key: 'ldn', active: false },
          ],
        },
      ],
    };
  },
  mounted() {
    this.item = this.$route.path;
  },
  computed: {
    drawerLeft() {
      return this.$store.state.app.drawerLeft;
    },
    favs() {
      return this.$store.state.app.favs;
    },
  },
  methods: {
    removeBookmark(item) {
      this.$store.commit('removeBookmark', item.route);
    },
    onItemActiveChange(cat, key, val) {
      const isEvt = cat === 'event';
      const evt = this.views[0].items.filter((item) => item.active);
      const evtRes = evt.map((item) => item.key).join('~');
      const cnt = this.views[1].items.filter((item) => item.active);
      const cntRes = cnt.map((item) => item.key).join('~');
      const states = this.$store.state.list.filters.state.join('~') || 'all';
      this.$router.push({
        name: 'list',
        params: {
          services: isEvt ? evtRes : cntRes || 'all',
          listType: cat,
          states,
        },
      });
    },
  },
  watch: {
    $route(to, from) {
      this.item = this.$route.path;
      const listIndex = to.params.listType === 'event' ? 0 : 1;
      const noIndex = to.params.listType === 'event' ? 1 : 0;
      if (to.params.services) {
        this.views[listIndex].items.forEach((item) => {
          item.active = to.params.services.indexOf(item.key) >= 0;
        });
        this.views[noIndex].items.forEach((item) => {
          item.active = false;
        });
      }
      // if (to.params.content) {
      //   this.views[1].items.forEach(item => {
      //     item.active = to.params.content.indexOf(item.key) >= 0;
      //   });
      // }
      if (to.params.states) {
        // TODO: done/published/etc. states
        if (to.params.states === 'all') {
          this.$store.commit('setFilterParam', {key: 'state', value: null});
        } else {
          const states = to.params.states.split('~');
          const res = states.map((state) => {
            const val = parseInt(state, 10);
            if (!isNaN(val)) { return val; }
          });
          this.$store.commit('setFilterParam', {key: 'state', value: res});
        }
      }
    },
  },
};
</script>

<style>
.padL {
  padding-left: 56px;
}
</style>
